export default "__VITE_ASSET__BYOnBFmu__"